import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { inject, observer } from 'mobx-react';


@inject('AuthStore')
@observer
export default class PrivateRoute extends React.Component {

  render(){
    return (
      <Route { ...this.props.rest } render={ ({ location }) =>
          this.props.AuthStore.isAuthenticated ? (
              this.props.children
            ) : (
              <Redirect
                to={{
                  pathname: "/signin",
                  state: { from: location }
                }}
              />
            )
          }
      />
    );
  }
}